import React from 'react';
import './brandAssetsStartSection.scss';
import { ReactComponent as CoolDexIcon } from "./icons/CoolDexIcon.svg";
import { ReactComponent as RobotIcon } from "./icons/RobotIcon.svg";
import { ReactComponent as NfdIcon } from "./icons/NfdIcon.svg";
import { ReactComponent as SomethingCoolIcon } from "./icons/SomethingCoolIcon.svg";
import BrandAssetsStartBannerComponent from "./components/BrandAssetsStartBannerComponent";

const BrandAssetsStartSection = () => {
	return (
		<div className="brandAssetsStart">
			<div className="stars"></div>
			<div className="stars2"></div>
			<div className="stars3"></div>
			<div className="brandAssetsStart__content">
				<div className="brandAssetsStart__content_data">
					<div className="brandAssetsStart__content_data_title">
						<div className="stars"></div>
						<div className="stars2"></div>
						<div className="stars3"></div>
						<h1>NFD<br/>Brand Assets</h1>
						<span>Contains the most important NFD brand assets</span>
					</div>
					<div className="brandAssetsStart__content_data_images">
						<BrandAssetsStartBannerComponent />
					</div>
					<div className="brandAssetsStart__content_data_button">
						<button
							className="secondButton"
							onClick={() => {}}
						>
							<span>Download All Assets</span>
						</button>
					</div>
					<div className="stars"></div>
					<div className="stars2"></div>
					<div className="stars3"></div>
				</div>
				<div className="brandAssetsStart__content_images">
					<CoolDexIcon />
					<RobotIcon />
					<NfdIcon />
					<SomethingCoolIcon />
				</div>
			</div>
		</div>
	);
};

export default BrandAssetsStartSection;